import UserService from "./user.service";

class DataService {
  getTerms() {
    return UserService.getTerms();
  }

  setUser(user) {
    UserService.setUser(user);
  }

  getUser() {
    return UserService.getUser();
  }

  removeUser() {
    UserService.removeUser();
  }

  setLoginAttempts(valor) {
    localStorage.setItem("loginAttempts", valor);
  }

  getLoginAttempts() {
    return parseInt(localStorage.getItem("loginAttempts"), 10);
  }

  removeLoginAttempts() {
    localStorage.removeItem("loginAttempts");
  }

  setErrorMessage(message) {
    localStorage.setItem("errorMessage", JSON.stringify(message));
  }

  getErrorMessage() {
    return localStorage.getItem("errorMessage");
  }

  removeErrorMessage() {
    localStorage.removeItem("errorMessage");
  }

  setBlockLoginStart(valor) {
    localStorage.setItem("blockLoginStart", valor);
  }

  getBlockLoginStart() {
    return localStorage.getItem("blockLoginStart");
  }

  removeBlockLoginStart() {
    localStorage.removeItem("blockLoginStart");
  }

  setTimeToLogoutStart(valor) {
    localStorage.setItem("timeToLogoutStart", valor);
  }

  getTimeToLogoutStart() {
    return localStorage.getItem("timeToLogoutStart");
  }

  removeTimeToLogoutStart() {
    localStorage.removeItem("timeToLogoutStart");
  }

  proceedLogout() {
    let user = this.getUser();
    if (user) this.logout(user.token);

    this.removeUser();
    this.removeLoginAttempts();
    this.removeErrorMessage();
    this.removeTimeToLogoutStart();
  }

  logout(user) {
    UserService.logout(user);
  }

  requestNewPassword(email) {
    return UserService.requestNewPassword(email);
  }

  persistNewPassword(obj) {
    return UserService.persistNewPassword(obj);
  }
}

export default new DataService();
